import { DeleteConfirmationDialogComponent } from "./delete-confirmation-dialog/delete-confirmation-dialog.component";
import {
  IGetOneMaladie,
  IMaladieAccident,
} from "./../../services/agenda/imaladie";
import { MaladieService } from "./../../services/agenda/maladie.service";
import { filter } from "rxjs/operators";
import { AjouterMaladieDialogComponent } from "./ajouter-maladie-dialog/ajouter-maladie-dialog.component";
import { Prestation } from "./../../services/agenda/prestation";
import { CodesService } from "./../../services/codes/codes.service";
import {
  Component,
  OnInit,
  Input,
  Inject,
  Output,
  EventEmitter,
  SimpleChange,
} from "@angular/core";
import {
  CdkDragDrop,
  transferArrayItem,
  CdkDrag,
  CdkDropList,
} from "@angular/cdk/drag-drop";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { AppGlobals } from "../../app.globals";

import { Jour } from "../../services/agenda/jour";
import { Occupation } from "../../services/personnel/occupation";
import { AgendaService } from "../../services/agenda/agenda.service";
import { AjouterPrestaDialog } from "./ajouter-presta-dialog.component";

// angular material
import {
  MAT_TOOLTIP_DEFAULT_OPTIONS,
  MatTooltipDefaultOptions,
} from "@angular/material/tooltip";
import * as moment from "moment";
import { CodePrestation } from "app/services/codes/code-prestation";
import { IMaladie } from "./interface/imaladie";

//fontawesome
import {
  faCheckSquare,
  faSquarePlus,
  faSyringe,
  faParking,
} from "@fortawesome/free-solid-svg-icons";

/** Custom options the configure the tooltip's default show/hide delays. */
export const myCustomTooltipDefaults: MatTooltipDefaultOptions = {
  showDelay: 450,
  hideDelay: 0,
  touchendHideDelay: 450,
};

@Component({
  selector: "agenda-day",
  templateUrl: "agenda-day.component.html",
  providers: [
    { provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: myCustomTooltipDefaults },
  ],
})
export class AgendaDayComponent {
  @Input() agenda: Jour;
  @Input() modification: Boolean;
  @Input() estVerrouiller: boolean;
  @Input() recalculTotaux: Function;
  @Input() prestations: Prestation[];
  @Input() debutDefaut: String;
  @Input() reposDefaut: String;
  @Input() dureeDefaut: String;
  @Input() quantiteDefaut: number;
  @Input() montantDefaut: number;
  @Input() occupations: Occupation[];
  @Input() maladie: IMaladie[];
  @Input() verifie: boolean;
  @Input() avecPointage: boolean;
  @Input() avecMaladie: boolean;
  @Input() remplace: boolean;
  @Input() codesPrestation: CodePrestation[] = [];
  @Output() chargerAgenda = new EventEmitter<any>();

  occupJour: Occupation[] = [];
  faParking = faParking;
  faCheckSquare = faCheckSquare;
  faFileMedical = faSyringe;
  faSquarePlus = faSquarePlus;

  displayOnHoverCodePrestation: string = "";
  displayOnHoverComment: string = "";

  constructor(
    public dialog: MatDialog,
    public agendaService: AgendaService,
    public codesService: CodesService,
    private _maladieService: MaladieService
  ) { }

  ngOnInit() {
    this.calculTotal();
    this.sortPrestations();
    this.refreshOccupations();
  }

  ngOnChanges(changes: { [property: string]: SimpleChange }) {
    if (changes['occupations'] != null) {
      this.refreshOccupations();
    }
    if (changes['agenda'] != null) {
      this.sortPrestations();
    }
  }

  refreshOccupations() {
    this.occupJour = [];
    for (const occup of this.occupations) {
      const theDay = moment(this.agenda.Date).format("YYYYMMDD");
      if (
        occup.DateDebut <= theDay &&
        (occup.DateFin == null || occup.DateFin >= theDay)
      ) {
        this.occupJour.push(occup);
      }
    }
  }

  sortPrestations() {
    this.agenda.Prestations = this.agendaService.sortingAgendaPrestations(this.agenda.Prestations);
  }

  addPresta = function () {
    const clePO = AppGlobals.getClePO(this.occupJour);
    const cookie = JSON.parse(localStorage.getItem("gapSecretariat"));
    console.log("add presta : ", JSON.stringify(cookie));
    const dialogRef = this.dialog.open(AjouterPrestaDialog, {
      width: "350px",
      disableClose: true,
      data: {
        cle: null,
        clePO: clePO,
        code: cookie.agenda.options.code,
        debut: this.debutDefaut,
        repos: this.reposDefaut,
        duree: this.dureeDefaut,
        quantite: this.quantiteDefaut,
        montant: this.montantDefaut,
        codes: this.prestations,
        occupations: this.occupJour,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result != null) {
        const code = this.prestations.filter(
          (x) => x.CodePrestationCode === result.code
        )[0];
        const presta = new Prestation(
          -1,
          result.clePO,
          code.CleCodePrestation,
          code.CodePrestationCode,
          this.agenda.Date,
          result.debut,
          result.duree,
          result.repos,
          result.quantite,
          result.montant,
          code.TypeHeureJour,
          code.Signe,
          result.memoRemarque,
          code.CodePrestationEncodageHeure,
          code.CodePrestationCleUnite
        );
        this.setPrestaService(presta, true, false);
        cookie.agenda.options.code = code.CodePrestationCode;
        localStorage.setItem("gapSecretariat", JSON.stringify(cookie));
        this.agendaService.sortingAgendaPrestations(presta);
      }
    });
  };

  editPresta = function (index: number, modifiable: boolean) {
    const presta = this.agenda.Prestations[index];
    const dialogRef = this.dialog.open(AjouterPrestaDialog, {
      width: "350px",
      disableClose: true,
      data: {
        cle: presta.Cle,
        clePO: presta.ClePeriodeOccupation,
        code: presta.CodePrestationCode,
        debut: presta.Debut,
        duree: presta.DureeQte,
        repos: presta.Repos,
        quantite: presta.Quantite,
        montant: presta.MontantPaie,
        codes: this.prestations.filter(
          (code) => code.CodePrestationCleUnite == presta.CodePrestationCleUnite
        ),
        occupations: this.occupJour,
        modifiable: modifiable,
        memoRemarque: presta.MemoRemarque,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result != null) {
        const code = this.prestations.filter(
          (x) => x.CodePrestationCode === result.code
        )[0];
        const newPresta = new Prestation(
          presta.Cle,
          result.clePO,
          code.CleCodePrestation,
          code.CodePrestationCode,
          this.agenda.Date,
          this.agenda.Debut,
          result.duree,
          result.repos,
          result.quantite,
          result.montant,
          code.TypeHeureJour,
          code.Signe,
          result.memoRemarque,
          code.CodePrestationEncodageHeure,
          code.CodePrestationCleUnite
        );
        presta.ClePeriodeOccupation = result.clePO;
        presta.CleCodePrestation = code.CleCodePrestation;
        presta.CodePrestationCode = code.CodePrestationCode;
        presta.Debut = result.debut;
        presta.DureeQte = result.duree;
        presta.Repos = result.repos;
        presta.Quantite = result.quantite;
        presta.MontantPaie = result.montant;
        presta.TypeHeureJour = code.TypeHeureJour;
        presta.Signe = code.Signe;
        presta.MemoRemarque = result.memoRemarque;
        this.setPrestaService(newPresta, false, false);
        this.agendaService.sortingAgendaPrestations(newPresta);
      }
    });
  };

  editMaladie = function (cle: number) {
    const cookie = JSON.parse(localStorage.getItem("gapSecretariat"));
    const clePO = AppGlobals.getClePO(this.occupJour);

    this._maladieService.getOneMaladie(cle).subscribe({
      next: (data) => {
        let commentaire = data.Commentaire;
        const currentMaladie = this.maladie.filter(
          (m) => m.Cle === data.CleMaladieAccidentParam
        )[0];
        const dialogRef = this.dialog.open(AjouterMaladieDialogComponent, {
          width: "450px",
          disableClose: true,
          data: {
            maladie: this.maladie,
            occupations: this.occupJour,
            clePO: clePO,
            cle: data.Cle,
            codeMaladie: currentMaladie.Code,
            commentaire: atob(
              commentaire.substring(commentaire.indexOf(":") + 1)
            ),
            dateFirstMaladie: data.DateFirstMaladie,
            dateDebut: data.Debut,
            dateFin: data.Fin,
            prolongation: data.Prolongation,
            choixPremMaladie: data.TypeDateFirstMaladie,
            operation: "2",
          },
        });
        dialogRef.afterClosed().subscribe((result) => {
          if (result != null) {
            if (result.operation === 3) {
              this._maladieService.deleteMaladie(cle).subscribe(() => {
                this.chargerAgenda.emit();
              });
            } else {
              const code = this.maladie.filter(
                (x) => x.Code === result.codeMaladie
              )[0];
              const body: IMaladieAccident = {
                Debut: moment(result.dateDebut).format("YYYYMMDD"),
                Fin: moment(result.dateFin).format("YYYYMMDD"),
                ClePersonnel: result.clePO,
                ClePeriodeOccupation: result.clePO,
                CleMaladieAccidentParam: code.Cle,
                Cle: result.cle,
                Commentaire: result.commentaire,
                Prolongation: result.prolongation,
                TypeDateFirstMaladie: result.choixPremMaladie,
                DateFirstMaladie:
                  result.choixPremMaladie === 0
                    ? moment(result.dateMaladie).format("YYYYMMDD")
                    : null,
              };
              this._maladieService.setMaladie(body).subscribe(() => {
                this.chargerAgenda.emit();
              });
            }
          }
        });
      },
    });
  };

  setPrestaService(presta: Prestation, addPresta: boolean, clearDay: boolean) {
    if (presta.CodePrestationCleUnite == AppGlobals.CLE_UNITE_HEURE) {
      this.agendaService
        .setAgendaHeure(presta, clearDay)
        .subscribe((result) => {
          presta.Cle = result.Cle;
          if (clearDay === true) {
            this.agenda.Prestations = [];
          }
          if (addPresta === true) {
            this.agenda.Prestations.push(presta);
          }
          this.calculTotal();
        });
    } else {
      this.agendaService
        .setAgendaValeur(presta, clearDay)
        .subscribe((result) => {
          presta.Cle = result.Cle;
          if (clearDay === true) {
            this.agenda.Prestations = [];
          }
          if (addPresta === true) {
            this.agenda.Prestations.push(presta);
          }
        });
    }
  }

  removePresta = function (index: number) {
    const dialogRef = this.dialog.open(DeleteConfirmationDialogComponent, {
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (res === "true") {
        console.log(res);
        if (this.agenda.Prestations[index].CodePrestationCleUnite == AppGlobals.CLE_UNITE_HEURE) {
          this.agendaService.deleteAgendaHeure(this.agenda.Prestations[index].Cle).subscribe(
            result => {
              this.agenda.Prestations.splice(index, 1);
              this.calculTotal();
            }
          );
        } else {
          this.agendaService.deleteAgendaValeur(this.agenda.Prestations[index].Cle).subscribe(
            result => {
              this.agenda.Prestations.splice(index, 1);
              this.calculTotal();
            }
          );
        }
      }
    });
  };

  drop(event: CdkDragDrop<Prestation[]>) {
    console.log(event.previousContainer.data[event.previousIndex]);

    if (event.previousContainer !== event.container) {
      if (event.item.data.Cle === -1) {
        const presta = JSON.parse(JSON.stringify(event.item.data)); // object.create ne fonctionne pas car ne crée pas une copie distincte de prestation
        presta.Cle = -1;
        presta.Date = this.agenda.Date;
        presta.ClePeriodeOccupation = AppGlobals.getClePO(this.occupJour);
        if (presta.ClePeriodeOccupation == null) {
          const dialogRef = this.dialog.open(AjouterPrestaDialog, {
            width: "350px",
            disableClose: true,
            data: {
              cle: null,
              clePO: null,
              code: presta.CodePrestationCode,
              duree: presta.DureeQte,
              codes: this.prestations,
              occupations: this.occupJour,
              memoRemarque: presta.MemoRemarque,
            },
          });
          dialogRef.afterClosed().subscribe((result) => {
            if (result != null) {
              let code = this.prestations.filter(
                (x) => x.CodePrestationCode == result.code
              )[0];
              let presta = new Prestation(
                -1,
                result.clePO,
                code.CleCodePrestation,
                code.CodePrestationCode,
                this.agenda.Date,
                result.debut,
                result.repos,
                result.duree,
                result.quantite,
                result.montant,
                code.TypeHeureJour,
                code.Signe,
                result.memoRemarque,
                code.CodePrestationEncodageHeure,
                code.CodePrestationCleUnite
              );
              this.setPrestaService(presta, true, this.remplace);
            }
          });
        } else {
          this.setPrestaService(presta, true, this.remplace);
        }
      } else {
        const presta = event.previousContainer.data[event.previousIndex];
        presta.Date = this.agenda.Date;
        this.setPrestaService(presta, false, false);
        transferArrayItem(
          event.previousContainer.data,
          event.container.data,
          event.previousIndex,
          event.currentIndex
        );
      }
      this.calculTotal();
    }
  }

  id(): string {
    return "cdkDropList" + this.agenda.Day.toString();
  }

  getItemData(code: string, dureeQte: string): any {
    return { Code: code, DureeQte: dureeQte };
  }

  calculTotal() {
    this.agenda.DureeJour = 0;
    for (const presta of this.agenda.Prestations) {
      if (presta.CodePrestationCleUnite == AppGlobals.CLE_UNITE_HEURE)
        this.agenda.DureeJour =
          this.agenda.DureeJour +
          presta.Signe * AppGlobals.heureToMin(presta.DureeQte);
    }
    this.recalculTotaux();
  }

  getStrDureeJour(): string {
    if (this.agenda.DureeJour === this.agenda.DureeJourTheo) {
      return this.agenda.DureeJour === 0
        ? ""
        : AppGlobals.minToHeure(this.agenda.DureeJour);
    } else {
      return `${AppGlobals.minToHeure(
        this.agenda.DureeJour
      )}/${AppGlobals.minToHeure(this.agenda.DureeJourTheo)}`;
    }
  }

  checkDroppable = (drag?: CdkDrag, drop?: CdkDropList) => {
    return this.estModifiable();
  };

  estModifiable() {
    return (
      this.modification &&
      !this.agenda.AvecPointage &&
      !this.verifie &&
      this.occupJour.length > 0
    );
  }

  estPrestaHeure(presta: Prestation) {
    return presta.CodePrestationCleUnite == AppGlobals.CLE_UNITE_HEURE;
  }

  getFooterColorClass() {
    if (this.occupJour.length <= 0) {
      return "agenda-day-duree-no-po";
    } else if (this.agenda.DureeJour === this.agenda.DureeJourTheo) {
      return "agenda-day-duree-ok";
    } else if (this.agenda.DureeJour < this.agenda.DureeJourTheo) {
      return "agenda-day-duree-inf";
    } else {
      return "agenda-day-duree-sup";
    }
  }

  memoRemarqueVide(presta: Prestation): boolean {
    return presta.MemoRemarque == null || presta.MemoRemarque.trim() == "";
  }

  getCurrentCommentary(index: number) {
    const presta = this.agenda.Prestations[index];
    this.displayOnHoverComment = `${presta.MemoRemarque}`;
  }

  getCurrentPrestationLib(cleCode: number, index: number): void {
    const lib: any = this.codesPrestation.filter((x) => x.Cle === cleCode)[0];
    if (lib !== undefined) {
      if (lib.Libelle === null || lib.Libelle === '') {
        this.displayOnHoverCodePrestation = `${lib.Code}`;
      } else {
        this.displayOnHoverCodePrestation = `${lib.Code} - ${lib.Libelle}`;
      }
    }
  }

  onModificationChanged(UpdatedValue : Boolean) {

  }

}
